import { useTheme } from 'styled-components';
import { Button } from '../../ui/Button/Button';
import { ThemeType } from '../../../theme/themeType';
import S from './DeleteModalStyles';

type Props = {
  title: string;
  btnConfirmText?: string;
  onClose: () => void;
  onDelete: () => void;
};

function DeleteModal({
  title, btnConfirmText = 'Delete', onClose, onDelete,
} : Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  return (
    <S.Wrapper>
      <div className="title">
        {title}
      </div>
      <div className="actions">
        <Button
          className="button"
          padding="7px 40px"
          onClick={onClose}
        >Cancel
        </Button>
        <Button
          className="button"
          padding="7px 40px"
          onClick={onDelete}
          background={theme.colors.red}
        >{btnConfirmText}
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default DeleteModal;
